import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/virtual-machine-sandbox/page.tsx");
